import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';

@customElement('jv-progress')
export class JvProgress extends LitElement {
  static styles = css`
    :host {
      display: block;
    }
    .track {
      height: 0.55rem;
      background: var(--jv-color-tint);
      border: 1px solid var(--jv-color-border);
      border-radius: var(--jv-radius);
      overflow: hidden;
    }
    .fill {
      height: 100%;
      width: 0;
      background: var(--jv-color-accent);
    }
    :host([tone='amber']) .fill {
      background: var(--jv-color-amber);
    }
    :host([tone='dark']) .track {
      background: #2a2e2a;
      border-color: #444;
    }
    .meta {
      display: flex;
      justify-content: space-between;
      margin-bottom: 0.35rem;
      font-size: var(--jv-fs-xs);
      color: var(--jv-color-muted);
      font-family: var(--jv-font-mono);
    }
  `;

  @property({ type: Number }) value = 0;
  @property({ type: Number }) max = 100;
  @property() label = '';
  @property({ reflect: true }) tone: 'accent' | 'amber' | 'dark' = 'accent';

  render() {
    const pct = this.max === 0 ? 0 : Math.min(100, Math.round((this.value / this.max) * 100));
    return html`
      ${this.label
        ? html`<div class="meta">
            <span>${this.label}</span>
            <span>${this.value}/${this.max}</span>
          </div>`
        : ''}
      <div class="track">
        <div class="fill" style=${styleMap({ width: `${pct}%` })}></div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'jv-progress': JvProgress;
  }
}
